/**
 * NavigationBlocks
 */
import React from 'react';
/** Main description for this component. */
var NavigationBlocks = function (_a) {
    var children = _a.children, className = _a.className, ariaLabel = _a["aria-label"];
    var renderChildren = function (children) {
        return React.Children.map(children, function (child, index) { return (React.createElement("li", { key: index, className: "w-full md:w-1/2 lg:w-1/3 px-4", "data-cid": "NavigationBlockItem" }, React.cloneElement(child, child.props || {}))); });
    };
    return (React.createElement("nav", { "aria-label": ariaLabel, className: className, "data-cid": "NavigationBlocks" },
        React.createElement("ul", { className: "flex flex-wrap -mx-4" }, renderChildren(children))));
};
export default NavigationBlocks;
